import { MessageCircle } from 'lucide-react';
import { useTotalUnreadCount } from '../../../hooks/queries/useMessaging';
import { useSidecarStore } from '../../../store/useSidecarStore';

interface Props {
  disabled?: boolean;
  disabledTooltip?: string;
}

export function SidecarFloatingButton({ disabled, disabledTooltip }: Props) {
  const open = useSidecarStore((s) => s.open);
  const unread = useTotalUnreadCount();

  return (
    <button
      type="button"
      onClick={open}
      disabled={disabled}
      title={disabled ? disabledTooltip : 'Ouvrir la messagerie'}
      aria-label="Ouvrir la messagerie"
      className="hidden md:flex fixed bottom-4 right-4 z-40 w-14 h-14 items-center justify-center rounded-full bg-cime-primary text-white shadow-lg hover:opacity-90 transition disabled:opacity-40 disabled:cursor-not-allowed"
    >
      <MessageCircle className="w-6 h-6" />
      {unread > 0 && !disabled && (
        <span className="absolute -top-1 -right-1 min-w-5 h-5 px-1 flex items-center justify-center rounded-full bg-red-500 text-white text-xs font-medium">
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
